import { render, staticRenderFns } from "./secao-01-protocolo.vue?vue&type=template&id=d7f8d4ea"
import script from "./secao-01-protocolo.vue?vue&type=script&lang=js"
export * from "./secao-01-protocolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports